import { BroadbandPlanMember, show } from '@giffgaff/broadband-common'

import { BannersWithActions } from '@/components/organisms/Banners/BannersWithActions'
import { useDeleteBanner, useGetBanners } from '@/hooks/apiHooks'
import { ProfileOrder } from '@/api'

export type TBannersContainerProps = {
  memberId: string
  plan?: BroadbandPlanMember
  order?: ProfileOrder
}

export const BannersWithActionsContainer = ({ memberId, plan, order }: TBannersContainerProps) => {
  const {
    data: bannerData,
    error,
    refetch,
  } = useGetBanners(
    {
      memberId,
    },
    { queryKey: ['GetBanners', memberId, plan?.id], enabled: !!memberId },
  )

  // Update the appointment with the selected date and slot
  const { mutate: deleteBanner, error: deleteBannerError } = useDeleteBanner({
    onSuccess: () => {
      refetch()
    },
  })

  const errorMessage: string | undefined = error?.message ?? deleteBannerError?.message ?? undefined

  const dismissCallback = (bannerId: string) => {
    deleteBanner({ memberId, bannerId })
  }

  return (
    <BannersWithActions
      banners={bannerData?.banners}
      dismissCallback={dismissCallback}
      errorMessage={errorMessage}
      order={order}
      plan={plan}
      showAgentChat={show}
    />
  )
}

export default BannersWithActionsContainer
